import { useState, useCallback } from "react";

interface UseMeetingModalStateReturn {
  showConfirmation: boolean;
  showAttendeeInfo: boolean;
  openConfirmation: () => void;
  closeConfirmation: () => void;
  openAttendeeInfo: () => void;
  closeAttendeeInfo: () => void;
  resetModals: () => void;
}

export function useMeetingModalState(): UseMeetingModalStateReturn {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showAttendeeInfo, setShowAttendeeInfo] = useState(false);

  const openConfirmation = useCallback(() => {
    setShowConfirmation(true);
  }, []);

  const closeConfirmation = useCallback(() => {
    setShowConfirmation(false);
  }, []);

  const openAttendeeInfo = useCallback(() => {
    setShowAttendeeInfo(true);
  }, []);

  const closeAttendeeInfo = useCallback(() => {
    setShowAttendeeInfo(false);
  }, []);

  const resetModals = useCallback(() => {
    setShowConfirmation(false);
    setShowAttendeeInfo(false);
  }, []);

  return {
    showConfirmation,
    showAttendeeInfo,
    openConfirmation,
    closeConfirmation,
    openAttendeeInfo,
    closeAttendeeInfo,
    resetModals,
  };
}
